import React, { Component } from 'react';
import { Card, CardBody } from 'reactstrap';
import { SlButton, SlPageTitle, SlFormEntryRow, SlBusyIndicator, SlSectionLabel } from '../editors'
import { metadataService, newLoanStepperService, ProfileApi, UserBasisApi, workflowService, registrationService, userService, SessionService, ProfileService } from '../../_services'
import { connect } from "react-redux";
import { history } from "../../_helpers";
import { registrationActions, newLoanActions, refinanceIncreaseLoanActions, profileActions, userActions } from "../../_actions";
import { workflowConstants } from '../../_constants';

import { IdentificationType } from "./IdentificationType";
import { AddressInfo } from "./AddressInfo";
import { AccountInfo } from "./AccountInfo";
import Stepper from "./Stepper";
import qs from 'query-string';
import { registrationConstants } from "../../_constants";
import pencil from '../images/SL-pencil.svg';

class PersonalInfo extends Component {
    static displayName = PersonalInfo.name;

    constructor(props) {
        super(props);

        this.state = {
            formValue: {
                firstName: this.props.firstName,
                lastName: this.props.lastName,
                email: this.props.email,
                confirmEmail: this.props.confirmEmail,
                mobilePhone: this.props.mobileNumber,
                alternateMobilePhone: this.props.alternateMobileNumber,
                requestedAmount: this.props.requestedAmount,
                preApprovalCode: this.props.preApprovalCode,
                address1: this.props.address1 ? this.props.address1 : '',
                address2: this.props.address2 ? this.props.address2 : '',
                city: this.props.city ? this.props.city : '',
                state: this.props.userState ? this.props.userState : '',
                postalCode: this.props.postalCode ? this.props.postalCode : '',
                socialSecurityNumber: this.props.socialSecurityNumber ? this.props.socialSecurityNumber : '',
                individualTaxIdentificationNumber: this.props.individualTaxIdentificationNumber ? this.props.individualTaxIdentificationNumber : '',
                dateOfBirth: this.props.dateOfBirth ? this.props.dateOfBirth : '',
                years: this.props.years ? this.props.years : '',
                months: this.props.months ? this.props.months : '',
                rentOrOwn: 0,
                residenceType: this.props.residenceType ? this.props.residenceType : "",
                monthlyResidencePayment: this.props.monthlyResidencePayment ? this.props.monthlyResidencePayment : "",
                sendMobileNotifications: true,
                userHash: ''
            },
            isEdit: false,
            readOnly: false,
            ssnItinError: false,
            addressInfoError: false,
            accountInfoError: false,
            formError: false,
            dobError: false,
            fieldErrors: [],
            steps: [],
            currentStep: '',
            canMoveBack: false,
            canMoveForward: true,
            isBusy: false,
            hiddenAccountInfoFields: [
                "FirstName", "LastName", "DateOfBirth", "Email", "ConfirmEmail", "MobilePhone", "AlternateMobilePhone", "SendMobileNotifications", "LanguagePreference"
            ],
            workflowId: null
        };
        this.handleInput = this.handleInput.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.formHasError = this.formHasError.bind(this);
        this.handleChangeState = this.handleChangeState.bind(this);
        this.isAddressValid = this.isAddressValid.bind(this);
        this.isAccountInfoValid = this.isAccountInfoValid.bind(this);
        this.isIdentificationTypeValid = this.isIdentificationTypeValid.bind(this);
        this.componentErrorChecker = this.componentErrorChecker.bind(this);
    }

    //TODO: form validation bug update: each component is stepping on the next when it mounts. Personal Info is last to mount,
    // and it's clearing the form errors found. 

    componentDidMount() {
        let newState = {
            ...this.state
        };
        let query = {};
        // check for query param indicating user navigated here by edit pencil
        if (this.props.location.search) {
            query = qs.parse(this.props.location.search);
            if (query.edit) {
                newState.isEdit = query.edit;
            }
        }

        let workflowData = workflowService.getCurrentWorkflowStepData();

        if (workflowData) {
            newState.steps = newLoanStepperService(workflowData.workflowId);
            newState.currentStep = workflowData.currentStepperStep;
            newState.canMoveBack = workflowData.canMoveBack;
            newState.canMoveForward = workflowData.canMoveForward;
            newState.workflowId = workflowData.workflowId;

            let registrationPersonalInfo = SessionService.getPersonalInfo();

            if (registrationPersonalInfo) {
                newState.formValue = {
                    firstName: registrationPersonalInfo.firstName,
                    lastName: registrationPersonalInfo.lastName,
                    email: registrationPersonalInfo.email,
                    confirmEmail: registrationPersonalInfo.email,
                    mobilePhone: registrationPersonalInfo.mobileNumber ? registrationPersonalInfo.mobileNumber : registrationPersonalInfo.mobilePhone,
                    alternateMobilePhone: registrationPersonalInfo.alternateMobileNumber,
                    addressId: registrationPersonalInfo.addressId,
                    address1: registrationPersonalInfo.address1,
                    address2: registrationPersonalInfo.address2,
                    city: registrationPersonalInfo.city,
                    state: registrationPersonalInfo.state,
                    postalCode: registrationPersonalInfo.postalCode,
                    socialSecurityNumber: registrationPersonalInfo.socialSecurityNumber,
                    individualTaxIdentificationNumber: registrationPersonalInfo.individualTaxIdentificationNumber,
                    dateOfBirth: registrationPersonalInfo.dateOfBirth,
                    years: registrationPersonalInfo.years,
                    months: registrationPersonalInfo.months,
                    rentOrOwn: registrationPersonalInfo.rentOrOwn ?
                        registrationPersonalInfo.rentOrOwn
                        : registrationPersonalInfo.ownResidence == true ? 1 : 0,
                    residenceType: registrationPersonalInfo.residenceType,
                    requestedAmount: registrationPersonalInfo.requestedAmount,
                    preApprovalCode: registrationPersonalInfo.preApprovalCode,
                    userHash: registrationPersonalInfo.userHash,
                    monthlyResidencePayment: registrationPersonalInfo.monthlyResidencePayment

                };
                if (workflowData.workflowId === workflowConstants.NEW_LOAN_WORKFLOW) {
                    newState.ssnItinError = !registrationPersonalInfo.preApprovalCode || registrationPersonalInfo.preApprovalCode == "" ? this.props.ssnItinError : false;
                    newState.accountInfoError = this.props.accountInfoError;
                    newState.addressInfoError = this.props.addressInfoError;
                }
                // else {
                //     newState.readOnly = true;
                // }
                this.handleChangeState(newState);
            }
            else {
                if (!this.props.loggedIn) {
                    history.push("/SignUpCustomerStatus");
                }
                else {
                    this.setState({ isBusy: true });
                    ProfileApi.getExtendedProfileInfo().then(response => {
                        if (response.data) {
                            registrationPersonalInfo = ProfileService.loadExtendedProfileInfoInSession(response.data).personalInfo
                            newState.formValue = {
                                firstName: registrationPersonalInfo.firstName,
                                lastName: registrationPersonalInfo.lastName,
                                email: registrationPersonalInfo.email,
                                confirmEmail: registrationPersonalInfo.email,
                                mobilePhone: registrationPersonalInfo.mobileNumber ? registrationPersonalInfo.mobileNumber : registrationPersonalInfo.mobilePhone,
                                alternateMobilePhone: registrationPersonalInfo.alternateMobileNumber,
                                addressId: registrationPersonalInfo.addressId,
                                address1: registrationPersonalInfo.address1,
                                address2: registrationPersonalInfo.address2,
                                city: registrationPersonalInfo.city,
                                state: registrationPersonalInfo.state,
                                postalCode: registrationPersonalInfo.postalCode,
                                socialSecurityNumber: registrationPersonalInfo.socialSecurityNumber,
                                individualTaxIdentificationNumber: registrationPersonalInfo.individualTaxIdentificationNumber,
                                dateOfBirth: registrationPersonalInfo.dateOfBirth,
                                years: registrationPersonalInfo.years,
                                months: registrationPersonalInfo.months,
                                rentOrOwn: registrationPersonalInfo.rentOrOwn ?
                                    registrationPersonalInfo.rentOrOwn
                                    : registrationPersonalInfo.ownResidence == true ? 1 : 0,
                                residenceType: registrationPersonalInfo.residenceType,
                                requestedAmount: registrationPersonalInfo.requestedAmount,
                                preApprovalCode: registrationPersonalInfo.preApprovalCode,
                                userHash: registrationPersonalInfo.userHash,
                                monthlyResidencePayment: registrationPersonalInfo.monthlyResidencePayment
                            };
                            this.handleChangeState(newState);
                        }
                    }).finally(() => this.setState({ isBusy: false }));
                }
            }
        }
        else {
            history.push("/LogInMain");
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { ssnItinError, addressInfoError, accountInfoError } = this.props;

        let idNumberError = ssnItinError;
        if (this.state.formValue.preApprovalCode || this.state.workflowId == workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW) {
            idNumberError = false;
        }

        let checkState = {
            ssnItinError: idNumberError,
            addressInfoError,
            accountInfoError
        }
        let hasError = this.formHasError(checkState);

        let prevError = true;
        if (prevProps) {
            let prevCheckState = {
                ssnItinError: !this.state.formValue.preApprovalCode || this.state.workflowId != workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW ? prevProps.ssnItinError : false,
                addressInfoError: prevProps.addressInfoError,
                accountInfoError: prevProps.accountInfoError
            }
            prevError = this.formHasError(prevCheckState);
        }

        if (prevError != hasError) {
            this.setState({
                formError: hasError,
                ssnItinError: idNumberError,
                addressInfoError,
                accountInfoError
            })
        }
    }

    handleInput = ({ target: { name, value } }) => {

        const formValue = { ...this.state.formValue, [metadataService.jsonFieldName(name)]: value };
        let newState = {
            ...this.state,
            formValue: formValue
        };

        if (name == "socialSecurityItin") {
            if (value.SocialSecurityNumber) {
                newState.formValue.socialSecurityNumber = value.SocialSecurityNumber;
                newState.ssnItinError = !value.isValid;
            }
            else if (value.IndividualTaxIdentificationNumber) {
                newState.formValue.individualTaxIdentificationNumber = value.IndividualTaxIdentificationNumber;
                newState.ssnItinError = !value.isValid;
            }
        }

        if (name === "AddressInfo") {
            newState.addressInfoError = !value.isValid;
            newState.formValue.address1 = value.address1;
            newState.formValue.address2 = value.address2;
            newState.formValue.city = value.city;
            newState.formValue.state = value.state;
            newState.formValue.postalCode = value.postalCode;
            newState.formValue.months = value.months;
            newState.formValue.years = value.years;
            newState.formValue.rentOrOwn = parseInt(value.rentOrOwn);
            newState.formValue.residenceType = value.residenceType;
            newState.formValue.monthlyResidencePayment = value.monthlyResidencePayment;
        }

        if (name === "AccountInfo") {
            newState.accountInfoError = !value.isValid;
            newState.formValue.firstName = value.firstName;
            newState.formValue.lastName = value.lastName;
            newState.formValue.dateOfBirth = value.dateOfBirth;
            newState.formValue.email = value.email;
            newState.formValue.confirmEmail = value.confirmEmail;
            newState.formValue.mobilePhone = value.mobilePhone;
            newState.formValue.alternateMobilePhone = value.alternateMobilePhone;
            newState.formValue.sendMobileNotifications = value.sendMobileNotifications;
        }

        this.handleChangeState(newState);
    };

    handleChangeState(newState) {
        newState.formError = this.formHasError(newState);
        this.setState(newState);
    }

    handleSubmit = () => {
        const { dispatch } = this.props;

        let formError = this.handleValidation();

        if (!formError) {
            var incompleteLead = {
                "firstName": this.state.formValue.firstName,
                "lastName": this.state.formValue.lastName,
                "email": this.state.formValue.email,
                "mobileNumber": this.state.formValue.mobilePhone,
                "alternateMobileNumber": this.state.formValue.alternateMobilePhone,
                "state": this.state.formValue.state,
                "requestedAmount": this.state.formValue.requestedAmount
            };
            newLoanActions.validateState(incompleteLead, dispatch).then(stateData => {
                var newUserHash = this.state.formValue.userHash;

                var hashSSN = this.state.formValue.socialSecurityNumber;
                if (!hashSSN) {
                    hashSSN = this.state.formValue.individualTaxIdentificationNumber;
                }
                var userHashRequest = {
                    "DateOfBirth": this.state.formValue.dateOfBirth,
                    "SSN": hashSSN
                };

                const userHashThenable = {
                    then: async (onFulfilled) => {
                        if (newUserHash) {
                            onFulfilled(newUserHash);
                        } else {
                            let hashResponse = await registrationService.getUserHash(userHashRequest);
                            onFulfilled(hashResponse.data);
                        }
                    }
                }

                userHashThenable.then(userHash => {
                    let personalInformation = {
                        firstName: this.state.formValue.firstName,
                        lastName: this.state.formValue.lastName,
                        email: this.state.formValue.email,
                        confirmEmail: this.state.formValue.confirmEmail,
                        mobileNumber: this.state.formValue.mobilePhone,
                        alternateMobileNumber: this.state.formValue.alternateMobilePhone,
                        addressId: this.state.formValue.addressId,
                        address1: this.state.formValue.address1,
                        address2: this.state.formValue.address2,
                        city: this.state.formValue.city,
                        state: this.state.formValue.state,
                        postalCode: this.state.formValue.postalCode,
                        socialSecurityNumber: this.state.formValue.socialSecurityNumber,
                        individualTaxIdentificationNumber: this.state.formValue.individualTaxIdentificationNumber,
                        dateOfBirth: this.state.formValue.dateOfBirth,
                        years: this.state.formValue.years,
                        months: this.state.formValue.months,
                        preApprovalCode: this.state.formValue.preApprovalCode,
                        requestedAmount: this.state.formValue.requestedAmount,
                        rentOrOwn: this.state.formValue.rentOrOwn,
                        monthlyResidencePayment: this.state.formValue.monthlyResidencePayment,
                        residenceType: this.state.formValue.residenceType,
                        userHash: userHash
                    };

                    if (this.state.isEdit) {
                        const { workflowId } = this.state;
                        let currentPersonalInformation = SessionService.getPersonalInfo();
                        SessionService.setPersonalInfo(personalInformation);
                        dispatch({ type: registrationConstants.PERSONAL_INFORMATION_REQUEST, personalInformation });
                        if ((currentPersonalInformation.state === personalInformation.state && currentPersonalInformation.userHash === personalInformation.userHash) || (workflowId ===
                            workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW ||
                            workflowId ===
                            workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW)) {
                            if (
                                workflowId ===
                                workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW ||
                                workflowId ===
                                workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW
                            ) {
                                history.push("/Refinance/Summary");
                            } else {
                                history.push("/ConfirmationSummary");
                            }
                        } else {
                            userService.saveLPXRelatedItems(personalInformation.state)
                                .then(() => {

                                    SessionService.setFundingInformation(null);
                                    history.push({ pathname: "FundingSelection", search: "edit=true" });
                                }
                                );
                        }
                    } else {
                        let currentStepData = workflowService.getCurrentWorkflowStepData();
                        userService.saveLPXRelatedItems(personalInformation.state)
                            .then(lpxResult => {
                                if (currentStepData) {
                                    if (currentStepData.workflowId === workflowConstants.NEW_LOAN_WORKFLOW) {
                                        dispatch(registrationActions.handlePersonalInformationRequest(personalInformation));
                                    } else if (currentStepData.workflowId === workflowConstants.NEW_LOAN_LOGGED_IN_WORKFLOW &&
                                        this.props.loggedIn) {
                                        dispatch(newLoanActions.handlePersonalInformationRequest(personalInformation));
                                    } else if ((currentStepData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW
                                        || currentStepData.workflowId === workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW) &&
                                        this.props.loggedIn) {
                                        dispatch(refinanceIncreaseLoanActions.handlePersonalInformationRequest(personalInformation));
                                    }
                                }
                            });
                    }
                });
            });
        }
    }

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(registrationActions.handlePersonalInformationBackRequest());
    }

    handleValidation = () => {
        let formError = this.formHasError(this.state);
        let newState = {
            formError: formError
        };
        this.setState(newState);

        return formError;

    };

    isAddressValid(fieldName, isValid) {
        return { formError: !isValid, addressInfoError: !isValid }
    }

    isAccountInfoValid(fieldName, isValid) {
        return { formError: !isValid, accountInfoError: !isValid }
    }

    isIdentificationTypeValid(fieldName, isValid) {
        return { formError: !isValid, ssnItinError: !isValid }
    }

    componentErrorChecker(checkFunction) {
        let errorState = checkFunction; // function referenced as isValid on the child component as a prop;
        let keys = Object.keys(errorState);
        let formError = keys[0]; // formError position
        let key = keys[1]; // the key to the input field we are checking for errors

        let newState = {
            [key]: errorState[key]
        }

        this.props.actions.personalInfoErrorChecker(newState);
    }

    formHasError(checkState) {
        return ((checkState.ssnItinError) || (checkState.addressInfoError) || (checkState.accountInfoError));
    }

    toggleReadOnly = (e) => {
        e.preventDefault();
        if (this.state.readOnly) {
            this.setState({ readOnly: false, hiddenAccountInfoFields: ["DateOfBirth", "LanguagePreference"] });

        }
        else {
            let hiddenFields = ["DateOfBirth", "Email", "ConfirmEmail", "MobilePhone", "SendMobileNotifications", "LanguagePreference"];
            this.setState({ readOnly: true, hiddenAccountInfoFields: hiddenFields });
        }
    }

    render() {
        const { loggedIn, error, steps, currentStep } = this.props;
        const { formError, firstNameError, workflowId } = this.state;

        var identityType = this.state.formValue.individualTaxIdentificationNumber ?
            { individualTaxIdentificationNumber: this.state.formValue.individualTaxIdentificationNumber } :
            { socialSecurityNumber: this.state.formValue.socialSecurityNumber };
        const { preApprovalCode } = this.state.formValue;
        var accountInfo = {
            dateOfBirth: this.state.formValue.dateOfBirth,
            firstName: this.state.formValue.firstName,
            lastName: this.state.formValue.lastName,
            email: this.state.formValue.email,
            confirmEmail: this.state.formValue.confirmEmail,
            mobilePhone: this.state.formValue.mobilePhone,
            alternateMobilePhone: this.state.formValue.alternateMobilePhone,
            sendMobileNotifications: this.state.formValue.sendMobileNotifications
        };

        var addressInfo = {
            address1: this.state.formValue.address1,
            address2: this.state.formValue.address2,
            city: this.state.formValue.city,
            state: this.state.formValue.state,
            postalCode: this.state.formValue.postalCode,
            months: this.state.formValue.months,
            years: this.state.formValue.years,
            rentOrOwn: parseInt(this.state.formValue.rentOrOwn),
            monthlyResidencePayment: this.state.formValue.monthlyResidencePayment,
            residenceType: this.state.formValue.residenceType,
        };

        return (
            <div className="PersonalInfo">

                {steps && currentStep && (
                    <Stepper
                        stepData={this.props.steps}
                        currentStep={this.props.currentStep}
                    />
                )}
                <SlPageTitle pageName="YourInformation" />
                {this.state.isBusy && (
                    <SlBusyIndicator visible={this.state.isBusy} />
                )}
                {!this.state.isBusy && (
                    <div>
                        <Card>
                            <CardBody className="noPadBottom">
                                {(!this.props.loggedIn && (!preApprovalCode || preApprovalCode == "")) && workflowId !== workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW && (
                                    <div>
                                        {this.props.disclosure.softHit &&
                                            <h3 className="will-not-impact">{metadataService.getMessage("WillNotImpactCreditScore")}</h3>
                                        }
                                        <IdentificationType
                                            name="socialSecurityItin"
                                            value={identityType}
                                            isRequired={true}
                                            showLabel={true}
                                            fieldErrors={this.state.fieldErrors}
                                            onChange={this.handleInput}
                                            isValid={(name, isValid) => this.componentErrorChecker(this.isIdentificationTypeValid(name, isValid))}
                                            requireReEntry={true}
                                            />
                                    </div>
                                )}
                                {workflowId == workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW ?
                                    (
                                        <AccountInfo
                                            name="AccountInfo"
                                            showLabel={true}
                                            readOnly={this.state.readOnly}
                                            value={accountInfo}
                                            onChange={this.handleInput}
                                            isValid={(name, isValid) => this.componentErrorChecker(this.isAccountInfoValid(name, isValid))}
                                            fieldErrors={this.state.fieldErrors}
                                            hiddenFields={["DateOfBirth", "LanguagePreference", "FirstName", "LastName", "Email", "ConfirmEmail", "MobilePhone", "AlternateMobilePhone", "SendMobileNotifications",]}
                                        />
                                    )
                                    : (this.props.loggedIn
                                        && workflowId != workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW
                                        && workflowId != workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW) ?
                                        (
                                            <AccountInfo
                                                name="AccountInfo"
                                                showLabel={true}
                                                readOnly={this.state.readOnly}
                                                value={accountInfo}
                                                onChange={this.handleInput}
                                                isValid={(name, isValid) => this.componentErrorChecker(this.isAccountInfoValid(name, isValid))}
                                                fieldErrors={this.state.fieldErrors}
                                                hiddenFields={this.state.hiddenAccountInfoFields}
                                                readOnlyFields={["MobilePhone"]}
                                            />)
                                        : this.props.loggedIn &&
                                            (workflowId == workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW
                                                || workflowId == workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW) ?
                                            (
                                                <AccountInfo
                                                    name="AccountInfo"
                                                    showLabel={true}
                                                    readOnly={false}
                                                    value={accountInfo}
                                                    onChange={this.handleInput}
                                                    isValid={(name, isValid) => this.componentErrorChecker(this.isAccountInfoValid(name, isValid))}
                                                    fieldErrors={this.state.fieldErrors}
                                                    readOnlyFields={["MobilePhone"]}
                                                    hiddenFields={["DateOfBirth", "LanguagePreference", "FirstName", "LastName", "Email", "ConfirmEmail", "MobilePhone", "AlternateMobilePhone", "SendMobileNotifications",]}
                                                />)
                                            : this.state.formValue.userHash && (!preApprovalCode || preApprovalCode == "") ?
                                                (
                                                    <AccountInfo
                                                        name="AccountInfo"
                                                        showLabel={true}
                                                        value={accountInfo}
                                                        onChange={this.handleInput}
                                                        isValid={(name, isValid) => this.componentErrorChecker(this.isAccountInfoValid(name, isValid))}
                                                        fieldErrors={this.state.fieldErrors}
                                                        hiddenFields={["FirstName", "LastName", "Email", "ConfirmEmail", "MobilePhone", "AlternateMobilePhone", "SendMobileNotifications", "LanguagePreference"]}
                                                    />)
                                                : this.state.formValue.userHash && preApprovalCode ?
                                                    (
                                                        <AccountInfo
                                                            name="AccountInfo"
                                                            showLabel={true}
                                                            value={accountInfo}
                                                            onChange={this.handleInput}
                                                            isValid={(name, isValid) => this.componentErrorChecker(this.isAccountInfoValid(name, isValid))}
                                                            fieldErrors={this.state.fieldErrors}
                                                            hiddenFields={["FirstName", "LastName", "Email", "ConfirmEmail", "MobilePhone", "AlternateMobilePhone", "SendMobileNotifications", "LanguagePreference", "DateOfBirth"]}
                                                        />)
                                                    : preApprovalCode ?
                                                        (
                                                            <AccountInfo
                                                                name="AccountInfo"
                                                                showLabel={true}
                                                                value={accountInfo}
                                                                onChange={this.handleInput}
                                                                isValid={(name, isValid) => this.componentErrorChecker(this.isAccountInfoValid(name, isValid))}
                                                                fieldErrors={this.state.fieldErrors}
                                                                hiddenFields={["FirstName", "LastName", "Email", "ConfirmEmail", "MobilePhone", "AlternateMobilePhone", "SendMobileNotifications", "LanguagePreference", "DateOfBirth"]}
                                                            />)
                                                        :
                                                        (
                                                            <AccountInfo
                                                                name="AccountInfo"
                                                                showLabel={true}
                                                                value={accountInfo}
                                                                onChange={this.handleInput}
                                                                isValid={(name, isValid) => this.componentErrorChecker(this.isAccountInfoValid(name, isValid))}
                                                                fieldErrors={this.state.fieldErrors}
                                                                hiddenFields={["FirstName", "LastName", "Email", "ConfirmEmail", "MobilePhone", "AlternateMobilePhone", "SendMobileNotifications", "LanguagePreference"]}
                                                            />)
                                }
                                <SlSectionLabel sectionName={"WhereDoYouLive"} />
                                {!this.props.loggedIn && (
                                    <AddressInfo
                                        name="AddressInfo"
                                        showLabel={true}
                                        value={addressInfo}
                                        onChange={this.handleInput}
                                        isValid={(name, isValid) => this.componentErrorChecker(this.isAddressValid(name, isValid))}
                                        fieldErrors={this.state.fieldErrors}
                                    />)}
                                {(this.props.loggedIn
                                    && workflowId !== workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW
                                    && workflowId !== workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW) && (
                                        <AddressInfo
                                            name="AddressInfo"
                                            showLabel={true}
                                            readOnly={this.state.readOnly}
                                            value={addressInfo}
                                            onChange={this.handleInput}
                                            isValid={(name, isValid) => this.componentErrorChecker(this.isAddressValid(name, isValid))}
                                            fieldErrors={this.state.fieldErrors}
                                        />
                                    )}
                                {(this.props.loggedIn
                                    && (workflowId == workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW
                                        || workflowId == workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW)) && (
                                        <AddressInfo
                                            name="AddressInfo"
                                            showLabel={true}
                                            readOnly={false}
                                            value={addressInfo}
                                            onChange={this.handleInput}
                                            isValid={(name, isValid) => this.componentErrorChecker(this.isAddressValid(name, isValid))}
                                            fieldErrors={this.state.fieldErrors}
                                        />
                                    )}

                                {(this.props.loggedIn
                                    && this.state.readOnly
                                    && workflowId !== workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW
                                    && workflowId !== workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW) && (
                                        <SlFormEntryRow>
                                            <div className="text-center">
                                                <a href="" onClick={this.toggleReadOnly}>
                                                    {metadataService.getMessage("ChangeMyContactInformation")}
                                                </a>
                                            </div>
                                        </SlFormEntryRow>
                                    )}

                            </CardBody>
                        </Card>
                    </div>
                )}
                <SlFormEntryRow>
                    {this.state.isEdit ?
                        <div className="text-center">
                            <SlButton name="Save" size="lg" onClick={this.handleSubmit} />
                        </div>
                        :
                        <div className="text-center display-flex">
                            {this.state.canMoveBack && (
                                <div className="half-width">
                                    <SlButton name="Back" cssClass="backBtn" onClick={this.handleBack} />
                                </div>

                            )}
                            {this.state.canMoveForward && (
                                <div className="half-width">
                                    <SlButton name="Next" onClick={this.handleSubmit} disabled={this.state.formError} />

                                </div>
                            )}
                        </div>
                    }
                </SlFormEntryRow>
                <hr></hr>
                {this.props.disclosure.softHit &&
                    <p className="center-text-font-small">{metadataService.getMessage("ForTheInitialPurpose")}</p>
                }
            </div>
        );
    }
}

function mapStateToProps(store) {
    const { loggedIn } = store.authentication;

    const { existingCustomer, confirmationSummaryScreen, error, firstName, lastName, email, confirmEmail, mobileNumber, alternateMobileNumber, address1, address2, city, userState, state, postalCode, requestedAmount, socialSecurityNumber, individualTaxIdentificationNumber, years, months, dateOfBirth, language, completedSteps, formState, step } = store.registration;
    const { steps, currentStep, disclosure } = store.users;
    const { ssnItinError, accountInfoError, addressInfoError } = store.newLoan;
    return {
        loggedIn, confirmationSummaryScreen, existingCustomer, error, firstName, lastName, email, confirmEmail, mobileNumber, alternateMobileNumber, address1, address2, city, userState: userState ? userState : state, postalCode, requestedAmount, socialSecurityNumber, individualTaxIdentificationNumber, years, months, dateOfBirth, language, completedSteps, formState, steps, step,
        currentStep, ssnItinError, accountInfoError, addressInfoError, disclosure

    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
        actions: {
            personalInfoErrorChecker: (errorState) => {
                dispatch(newLoanActions.personalInfoErrorChecker(errorState));
            },
            loadProfile: () => {
                dispatch(profileActions.loadProfile());
            }
        }
    }
}

const connectedPersonalInfo = connect(mapStateToProps, mapDispatchToProps)(PersonalInfo);
export { connectedPersonalInfo as PersonalInfo };